module.exports = __webpack_public_path__ + "static/media/logo.72d7cd6c.svg";